import React from 'react';
// hover:border-2 hover:border-primary-dark hover:border-solid add if need
export default function BtnSmallDisabled({ children, ...restProps }) {
  return (
    <button {...restProps} className={`text-center bg-secondary-dark  w-150 h-14 text-primary-white`}>{children}</button>
  );
}
